{
  "title": "Registro de actividades",
  "subtitle": "Lo que cada persona ha estado haciendo en el espacio de trabajo.",
  "empty_title": "Sin actividad todavía",
  "empty_desc": "Cuando alguien cree, edite, complete, comente o asigne tareas, aparecerá aquí.",
  "empty_filtered": "No hay actividad de esta persona en el periodo consultado.",
  "load_more": "Cargar más",
  "loading": "Cargando…",
  "someone": "Alguien",
  "filter_person": "Persona",
  "filter_all_people": "Todo el equipo",
  "filter_event": "Acción",
  "filter_all_events": "Todas",
  "clear_filters": "Quitar filtros",
  "subject": {
    "task": "la tarea",
    "project": "el proyecto",
    "comment": "la tarea"
  },
  "event": {
    "created_task": "creó {subject} {name}",
    "updated_task": "actualizó {subject} {name}",
    "completed_task": "completó {subject} {name}",
    "deleted_task": "eliminó {subject} {name}",
    "assigned_task": "asignó {subject} {name} a {people}",
    "unassigned_task": "quitó de {subject} {name} a {people}",
    "created_project": "creó {subject} {name}",
    "updated_project": "actualizó {subject} {name}",
    "completed_project": "archivó {subject} {name}",
    "deleted_project": "eliminó {subject} {name}",
    "created_comment": "comentó en {subject} {name}",
    "updated_comment": "editó un comentario en {subject} {name}",
    "deleted_comment": "borró un comentario de {subject} {name}"
  },
  "event_label": {
    "created": "Creaciones",
    "updated": "Ediciones",
    "completed": "Completadas",
    "deleted": "Eliminaciones",
    "assigned": "Asignaciones",
    "unassigned": "Desasignaciones"
  }
}
